import { useAtomValue } from 'jotai';

import { appointmentPatientsAtom } from '../../modules/patientList/atoms';

export const useGetVideaId = (imagingPatientId?: string) => {
  const appointmentPatients = useAtomValue(appointmentPatientsAtom);

  if (!imagingPatientId) return undefined;

  return appointmentPatients.find(
    (patient) => patient.imagingPatientId === imagingPatientId,
  )?.videaId;
};
